module.exports = __webpack_public_path__ + "static/media/logo-donts-1.a16f8486.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-1.png
// module id = 1304
// module chunks = 0